import { useState } from 'react'
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import LinkIcon from '@mui/icons-material/Link'
import AddIcon from '@mui/icons-material/AddToPhotosOutlined'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

const TableActionsMenu = ({
  onConciliar,
  conciliarDisabled = false,
  extraActions = [],
  onReplicar,
  onEliminar,
  onEditar,
  deleting = false,
  deleteDisabled = false,
  reconciled = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const closeMenu = () => setAnchorEl(null)
  const runAction = (action, event) => {
    event.stopPropagation()
    closeMenu()
    action(event)
  }
  const actions = [
    { label: 'Conciliar', onClick: onConciliar, Icon: LinkIcon, disabled: conciliarDisabled },
    { label: 'Replicar', onClick: onReplicar, Icon: AddIcon },
    { label: deleting ? 'Eliminando...' : 'Eliminar', onClick: onEliminar, Icon: HighlightOffIcon, disabled: deleteDisabled },
    { label: 'Editar', onClick: onEditar, Icon: EditOutlinedIcon },
    ...extraActions
  ].filter(action => action.onClick)

  return (
    <>
      <button
        type='button'
        aria-label='Acciones'
        aria-haspopup='menu'
        aria-expanded={Boolean(anchorEl)}
        onClick={event => {
          event.stopPropagation()
          setAnchorEl(event.currentTarget)
        }}
        className={`inline-flex items-center gap-1 rounded-md border px-3 py-1.5 text-xs font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 ${
          reconciled
            ? 'border-transparent bg-accent2 text-white hover:opacity-90'
            : 'border-gray-200 bg-white text-slate-500 hover:bg-gray-50'
        }`}
      >
        {deleting ? 'Eliminando...' : reconciled ? 'Conciliado' : onConciliar ? 'Conciliar' : 'Acciones'}
        <KeyboardArrowDownIcon fontSize='small' />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{ 'aria-label': 'Acciones de vinculación' }}
        PaperProps={{ sx: { minWidth: 160, mt: 0.5, borderRadius: 2 } }}
      >
        {actions.map(({ label, onClick, Icon, disabled }) => (
          <MenuItem key={label} disabled={disabled} onClick={event => runAction(onClick, event)} sx={{ fontSize: 12 }}>
            {Icon && <ListItemIcon><Icon fontSize='small' /></ListItemIcon>}
            <ListItemText primary={label} primaryTypographyProps={{ fontSize: 12 }} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default TableActionsMenu
